import { Account } from '@types';

export type Amounts = {
  from?: string;
  to?: string;
};

export type QuoteInfo = {
  quoteSignature?: string;
  settlementDate?: string;
  amounts?: Amounts;
  rate?: string;
  rateValidityTime?: number;
  currencyPair?: string[];
};

export type AccountSelectionState = {
  accounts?: Account[];
  selectedFromAccountIban?: string;
  selectedToAccountIban?: string;
  selectedFromAccount?: Account;
  selectedToAccount?: Account;
  description?: string;
  quoteSignature?: string;
  settlementDate?: string;
  tradeId?: string;
  amounts?: Amounts;
  rate?: string;
  rateValidityTime?: number;
  direction?: string;
  currencyPair?: string[];
};

export enum ActionTypes {
  setAccounts = 'SET_ACCOUNTS',
  setSelectedFromAccountIban = 'SET_SELECTED_FROM_ACCOUNT_IBAN',
  setSelectedToAccountIban = 'SET_SELECTED_TO_ACCOUNT_IBAN',
  switchSelectedAccounts = 'SWITCH_SELECTED_ACCOUNTS',
  setAmounts = 'SET_AMOUNT',
  setDescription = 'SET_DESCRIPTION',
  setQuoteInfo = 'SET_QUOTE_INFO',
  setTradeId = 'SET_TRADE_ID',
  setDirection = 'SET_DIRECTION'
}

export type Actions =
  | {
      type: ActionTypes.setSelectedFromAccountIban;
      payload: string;
    }
  | {
      type: ActionTypes.setSelectedToAccountIban;
      payload: string;
    }
  | {
      type: ActionTypes.switchSelectedAccounts;
    }
  | {
      type: ActionTypes.setAccounts;
      payload: Account[];
    }
  | {
      type: ActionTypes.setAmounts;
      payload: { type: 'from' | 'to'; amount?: number };
    }
  | {
      type: ActionTypes.setDescription;
      payload: string;
    }
  | {
      type: ActionTypes.setQuoteInfo;
      payload: QuoteInfo;
    }
  | {
      type: ActionTypes.setTradeId;
      payload: string;
    }
  | {
      type: ActionTypes.setDirection;
      payload: string;
    };
